import { isSelectableAgeRange } from './Age'
import type { AgeRange } from './ArtBook'
import type { Gender } from './Gender'

export interface BookCreationInput {
  name: string
  ageRange: AgeRange | undefined
  gender: Gender
  imageUrl: string | undefined
  imageBase64?: string
  toapis?: string
  imageUuid?: string
  imagePath?: string
  themeId: string
  characterStyleId: string
}

export function validateBookCreationInput(input: BookCreationInput): string | undefined {
  if (!input.name.trim()) return 'Please add their first name.'
  if (!input.imageUrl || !input.imageBase64) return 'Please choose a photo to begin.'
  if (!input.imageUuid || !input.imagePath) return 'Please upload the photo again.'
  if (!isSelectableAgeRange(input.ageRange)) return 'Please choose their age range.'
  if (!input.themeId) return 'Please choose a book theme.'
  if (!input.characterStyleId) return 'Please choose how their character should look.'
}
